import React from 'react'
import { Box } from '@roo/roo'
import styles from './index.module.less'

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  gray?: boolean
  contentClassName?: string;
}

const Container: React.FC<ContainerProps> = ({ children, className, style = {}, contentStyle,  gray, contentClassName }) => (
  <div className={`${styles.wraper} ${className || ''}`}
    style={{
      backgroundColor: gray ? '#F7F7F7' : '#FFFFFF',
      ...style }}
  >
    <Box
      htmlType="div"
      className={`${styles.container}  ${contentClassName || ''}`}
      style={contentStyle}
    >
      {children}
    </Box>
  </div>
)

export default Container